<div class="panel-body bullhorn">
  <div>
    <h2 class="heading-underline">Bullhorn user restrictions</h2>
    <p>Filter which users will have access to the template</p>
  </div>
  <div class="bullhorn-filters">
    <app-bullhorn-user-restrictions [filtersFormArray]="filters"></app-bullhorn-user-restrictions>
  </div>

  @if (entity !== 'Candidate') {
    <div>
      <div>
        <h2 class="heading-underline">Bullhorn company restrictions</h2>
        <p>Filter which companies will have access to the template</p>
      </div>
      <div class="bullhorn-filters">
        <app-bullhorn-company-filters [filtersFormArray]="filters"></app-bullhorn-company-filters>
      </div>
    </div>
  }

  @if (entity === 'Placement') {
    <div>
      <div>
        <h2 class="heading-underline">Bullhorn placement restrictions</h2>
        <p>Filter which placements will have access to the template</p>
      </div>
      <div class="bullhorn-filters">
        <app-bullhorn-placement-filters [filtersFormArray]="filters"></app-bullhorn-placement-filters>
      </div>
    </div>
  }
</div>
